import { PRODUCT_NAMES } from '../constants';
import { processResponse } from '../utils';
const {
  SUITE
} = PRODUCT_NAMES;

const getSuiteUser = async (fetchGet, suiteUserUrl, accessibleProducts = []) => {
  const requestExplicitProducts = accessibleProducts.filter(el => el !== SUITE).join(',').toLowerCase();
  const param = requestExplicitProducts.length > 0 ? `requestExplicitProducts=${requestExplicitProducts}` : '';
  const char = suiteUserUrl.includes('?') ? '&' : '?';
  const query = param ? `${char}${param}` : '';
  const url = `${suiteUserUrl}${query}`;
  const result = await fetchGet(url);
  const suiteUser = await processResponse(result);
  return suiteUser;
};

export default getSuiteUser;
//# sourceMappingURL=getSuiteUser.js.map